import React from 'react';
import './titleImage.css';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

export class TitleImage extends React.Component {
	render() {
		const { title } = this.props;
		const isMobile = this.props.isMobile();
		var uri = title.uri
			? title.uri
			: title &&
			  title.images &&
			  title.images.filter(im => im.type === 'jacketCover').length > 0 &&
			  title.images.filter(im => im.type === 'jacketCover')[0].uri +
					'?height=600';
		const titleName = title.product ? title.product.name : 'Unknown Title';
		return (
			<div className="relative">
				{uri ? (
					<img
						alt={titleName}
						src={uri}
						className={
							!isMobile ? 'jacket-height' : 'jacket-height-mobile'
						}
					/>
				) : (
					<div
						className={
							!isMobile
								? 'no-jacket-scroller-outer'
								: 'no-jacket-scroller-outer-mobile'
						}>
						<div
							className={
								!isMobile
									? 'no-jacket-scroller-inner'
									: 'no-jacket-scroller-inner-mobile'
							}>
							<span className="bold">{titleName}</span>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withIsMobile(TitleImage);
